module.exports = __webpack_public_path__ + "img/rodrigo.2af86bd4.png";